import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { User } from 'models/User';
import { LoginDto } from 'models/dtos/LoginDto';

import { getFormattedUserData } from 'utils/AuthUtils';
import { FunctionsHelper } from 'utils/FunctionsHelper';

import MainBackendAxios from '../utils/MainBackendAxios';

export const AuthService = {
  login: async (
    loginParams: LoginDto
  ): Promise<ApiResponse<User | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(`/auth/login`, loginParams);
      const userData = response?.data?.data;
      return {
        success: true,
        status: response.status,
        data: getFormattedUserData(userData),
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  verifySession: async (
    token?: string
  ): Promise<ApiResponse<User | ApiErrorData>> => {
    try {
      let headers = {};

      if (token) {
        headers = {
          Authorization: `Bearer ${token}`,
        };
      }

      const response = await MainBackendAxios.post(
        `/auth/get-current-user`,
        {},
        { headers }
      );

      const userData = response.data.data;

      return {
        success: true,
        status: response.status,
        data: getFormattedUserData(userData),
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  logout: async (): Promise<ApiResponse<ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post('/auth/logout');
      console.log('response logout', response);
      return {
        success: true,
        status: response.status,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
